export default "/app/global-wrapper-client/static/1be170e93a02c6cb406438831bceb88c.ttf";